/*global chrome*/
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Footer from "./Footer";
import NocBanner from "components/PublicPagesReusable/NocBanner";
import Header from "./Header";
import ButtonComp from "components/PublicPagesReusable/ButtonComp";
import Frame1 from "../../assets/images/public-pages/Frame1.svg";
import Frame2 from "../../assets/images/public-pages/Frame2.svg";
import Frame3 from "../../assets/images/public-pages/Frame3.svg";
import Frame4 from "../../assets/images/public-pages/Frame4.svg";
import Frame5 from "../../assets/images/public-pages/Frame5.svg";
import Frame6 from "../../assets/images/public-pages/Frame6.svg";
import Frame7 from "../../assets/images/public-pages/Frame7.svg";
import Frame8 from "../../assets/images/public-pages/Frame8.svg";
import Frame9 from "../../assets/images/public-pages/Frame9.svg";
import Frame10 from "../../assets/images/public-pages/Frame10.svg";
import Frame11 from "../../assets/images/public-pages/Frame11.svg";
import Frame12 from "../../assets/images/public-pages/Frame12.svg";
import Frame13 from "../../assets/images/public-pages/Frame13.svg";
import Frame14 from "../../assets/images/public-pages/Frame14.svg";
import Frame15 from "../../assets/images/public-pages/Frame15.svg";
import Frame16 from "../../assets/images/public-pages/Frame16.svg";
import Frame17 from "../../assets/images/public-pages/Frame17.svg";
import Frame18 from "../../assets/images/public-pages/Frame18.svg";
import Frame19 from "../../assets/images/public-pages/Frame19.svg";
import Frame20 from "../../assets/images/public-pages/Frame11.svg";
import Complement from "../../assets/images/public-pages/complement.svg";
import Essential from "../../assets/images/public-pages/essential.svg";
import Professional from "../../assets/images/public-pages/professional.svg";
import Commuters from "../../assets/images/public-pages/commuters.svg";
import AppBannerCustom from "components/PublicPagesReusable/AppBannerCustom";
import ReusableHomePageSlider from "page/ReusableHomePageSlider";
import ScoreInfoCard from "components/PublicPagesReusable/ScoreInfoCard";
import SkillAreas from "components/PublicPagesReusable/SkillAreas";
import ContentImageSection from "components/PublicPagesReusable/ContentImageSection";
import Immigration from "../../assets/images/public-pages/victoria-take-test.png";
import Filter from "../../assets/images/public-pages/filter.svg";
import checkList from "../../assets/images/public-pages/check-list.svg";
import TestEnvironmentIcon from "../../assets/images/public-pages/TestEnvironmentIcon.png";
import flexibleIcon from "../../assets/images/public-pages/flexible-icon.svg";
import ReactHtmlParser from "react-html-parser";
import CtaBanner from "components/PublicPagesReusable/CtaBanner";
import FaqSection from "components/PublicPagesReusable/FaqSection";

const PteScoreSeo = React.memo(() => {
  const heroWorkTitle = () => {
    return (
      <h1 className="FS48 fw-500 top-section-text text-center">
        <span className="fw-600 text-success">PTE Score Calculator</span> —
        Predict Your PTE
        <br /> Overall Score Instantly
      </h1>
    );
  };

  const heroData = {
    badge: "Australia’s Leading English Proficiency Centre",
    title: heroWorkTitle,
    subtitle:
      "Wondering where you stand before taking the PTE? Or trying to figure out if your mock test scores are good enough for your visa application or university admission?",
    bottomStatsText: [
      { value: "50,000", highlight: "+", label: "Successful Students" },
      { value: "95", highlight: "%", label: "AI Scoring Accuracy" },
      { value: "29,000", highlight: "+", label: "Practiced Questions" },
    ],
    btnText: "Try Calculator Now",
    btnLink: "/auth/register",
    btn_outline: {
      text: "Try Free Mock Test",
      variant: "outline",
      link: "/auth/register",
    },
  };

  const images = [
    { src: Frame1, alt: "pte-score-1" },
    { src: Frame2, alt: "pte-score-2" },
    { src: Frame3, alt: "pte-score-3" },
    { src: Frame4, alt: "pte-score-4" },
    { src: Frame5, alt: "pte-score-5" },
    { src: Frame6, alt: "pte-score-6" },
    { src: Frame7, alt: "pte-score-7" },
    { src: Frame8, alt: "pte-score-8" },
    { src: Frame9, alt: "pte-score-9" },
    { src: Frame10, alt: "pte-score-10" },
    { src: Frame11, alt: "pte-score-11" },
    { src: Frame12, alt: "pte-score-12" },
    { src: Frame13, alt: "pte-score-13" },
    { src: Frame14, alt: "pte-score-14" },
    { src: Frame15, alt: "pte-score-15" },
    { src: Frame16, alt: "pte-score-16" },
    { src: Frame17, alt: "pte-score-17" },
    { src: Frame18, alt: "pte-score-18" },
    { src: Frame19, alt: "pte-score-19" },
    { src: Frame20, alt: "pte-score-20" },
  ];

  const heroDescriptionSection = () => {
    return (
      <div className="text-center d-flex align-items-center justify-content-center flex-column">
        <p className="sub-title text-center FS16FW500 w-75">
          Our free PTE score calculator helps you estimate your overall PTE
          Academic score based on your individual section scores — so you know
          exactly where you are and what you still need to work on.
          <br />
          <br />
          PTE scoring isn’t as straightforward as averaging your four section
          scores. The system uses an integrated scoring model where some tasks
          <br />
          contribute to multiple skill areas simultaneously. That’s why two
          students with seemingly similar section scores can end up with
          different overall results. Our calculator takes this into
          account, giving you a more accurate picture of your likely overall
          score.
        </p>
        <br />
        <br />
        <span
          className="itelic plus-sans fw-700 FS16FW500"
          style={{ color: "#182A4F", fontSize: "italic" }}
        >
          Enter your section scores and get your predicted PTE overall score in
          seconds.
        </span>
      </div>
    );
  };

  const PteIeltsScore = () => {
    return (
      <div className="text-center">
        <h3 className="FS48 fw-500 top-section-text text-center">
          <span className="fw-600 text-success">PTE-IELTS Score</span> Alignment
          (Official)
        </h3>
        <p className="sub-title text-center FS16FW500 w-75 mx-auto">
          The official alignment between PTE Academic scores and IELTS bands,
          per the Pearson PTE Academic Score Guide (July 2025), shows how your
          section-by-section PTE performance maps to IELTS equivalents. Note that
          alignment varies significantly by skill: for example, a PTE Speaking
          score of 76–82 aligns with IELTS 7.0, but the same IELTS 7.0 requires PTE Listening of
          58–63. When targeting a specific overall score for immigration or
          university admission, always verify section-by-section requirements.
        </p>
      </div>
    );
  };
  const headers = [
    "IELTS Band",
    "PTE Overall",
    "PTE Listening",
    "PTE Reading",
    "PTE Speaking",
    "PTE Writing",
  ];

  const rows = [
    ["4.5", "24–30", "26–32", "29–35", "14–23", "17–28"],
    ["5.0", "31–38", "33–39", "36–41", "24–38", "29–40"],
    ["5.5", "39–46", "40–46", "42–47", "39–53", "41–50"],
    ["6.0", "47–54", "47–52", "48–53", "54–65", "51–59"],
    ["6.5", "55–62", "53–57", "54–58", "66–75", "60–68"],
    ["7.0", "63–70", "58–63", "59–64", "76–82", "69–76"],
    ["7.5", "71–78", "64–68", "65–69", "83–87", "77–84"],
    ["8.0", "79–85", "69–74", "70–74", "88–89", "85–89"],
    ["8.5", "86–89", "75–80", "75–80", "90", "90"],
    ["9.0", "90", "81–90", "81–90", "-", "-"],
  ];

  const PteCibScore = () => {
    return (
      <div className="text-center mb-5">
        <h3 className="FS48 fw-500 top-section-text text-center">
          <span className="fw-600 text-success">PTE vs CLB</span> Score
          Comparison
        </h3>
        <p className="sub-title text-center FS16FW500">
          If you’re applying for Canadian immigration, you’ll need to convert
          your PTE Core scores to Canadian Language Benchmark (CLB) levels. The
          <br />
          CLB system is used by Immigration, Refugees and Citizenship Canada
          (IRCC) to assess language ability for programs like Express Entry,
          <br />
          Provincial Nominee Programs, and Canadian citizenship applications.
          <br />
          <br />
          Here’s how PTE Core scores map to CLB levels:
        </p>
      </div>
    );
  };

  const GoodPteScore = () => {
    return (
      <div className="text-center">
        <h3 className="FS48 fw-500 top-section-text text-center">
          What Is a<span className="fw-600 text-success">{" "}Good PTE Score?</span>
        </h3>
        <p className="sub-title text-center FS16FW500 w-75 mx-auto">
          What counts as a “good” score depends entirely on what you need it
          for. PTE scores range from 10 to 90, and different goals require different benchmarks. Here’s a practical breakdown:
        </p>
      </div>
    );
  };

  const GoodPteheaders = [
    "Purpose",
    "Typical Score Needed",
    "IELTS Equivalent",
  ];

  const GoodPterows = [
    [
      "Australian PR — Proficient English",
      "65+ overall (or each section)",
      "IELTS 7.0 overall",
    ],
    [
      "Australian PR — Superior English",
      "79+ overall (or each section)",
      "IELTS 8.0 overall",
    ],
    [
      "Australian Student Visa (Subclass 500)",
      "42+ overall",
      "IELTS 5.5 overall",
    ],
    [
      "UK visa & immigration (UKVI)",
      "43–58 depending on visa",
      "IELTS 4.0-5.0",
    ],
    ["New Zealand Skilled Migrant", "58+ each section", "IELTS 6.5 each band"],
    [
      "University admission (undergraduate)",
      "50–58 overall",
      "IELTS 6.0-6.5 overall",
    ],
    [
      "University admission (postgraduate)",
      "58–65 overall",
      "IELTS 6.5-7.0 overall",
    ],
    [
      "Nursing & healthcare (Australia)",
      "65+ each section",
      "IELTS 7.0 each band",
    ],
  ];

  const skillAreaTitle = () => {
    return (
      <h3 className="top-section-text FS56FW500 mb-4 white">
        <span className="text-success">PTE Score Report</span> Explained
      </h3>
    );
  };
  const lifestyleCards = [
    {
      title: "Overall Score (10–90)",
      text: "This is the single number most institutions and immigration authorities look at. It’s calculated from your combined performance across all communicative and enabling skills.",
      color: "rgba(255, 255, 255, 0)",
      img: Commuters,
      hoverColor: "#FFCC00",
    },
    {
      title: "Communicative Skills Scores",
      text: " Individual scores (10–90) for Speaking, Writing, Reading, and Listening. These are the scores that matter for visa applications where you need to meet minimums in each section — for example, “65 in each skill” for Australian PR.",
      color: "rgba(255, 255, 255, 0)",
      img: Professional,
      hoverColor: "#FF2D55",
    },
    {
      title: "Skills Breakdown",
      text: "A bar chart showing your performance in each of the four communicative skills relative to the overall scale.",
      color: "rgba(255, 255, 255, 0)",
      img: Essential,
      hoverColor: "#34C759",
    },
    {
      title: "Skills Profile (online access)",
      text: "When you log into your account, the online Skills Profile provides a deeper diagnostic breakdown showing performance in categories such as Open Response Speaking and Writing, Extended Writing, Short Speaking, and other areas. These performance descriptors help you understand which specific language abilities drove your score.",
      color: "rgba(255, 255, 255, 0)",
      img: Complement,
      hoverColor: "#007AFF",
    },
  ];
  const contentSection = () => {
    return (
      <h3 className="top-section-text FS40FW600">
        Improve Your {" "}
        <span className="text-success FS40FW600">
          PTE Score with AI Mock Tests
        </span>
      </h3>
    );
  };
  const laPreprationWorkTitle = () => {
    return (
      <h3 className="top-section-text FS40FW600">
        Why Use A{" "}
        <span className="text-success FS40FW600"> PTE Score Calculator? </span>
      </h3>
    );
  };

  const calculatorArray = [
    {
      icon: flexibleIcon,
      title: "Set realistic target scores before you start studying.",
      content: `
                <div class='text-start'>If you need 65+ overall for Australian PR, our calculator helps you understand what your<br/> current mock test scores mean in terms of your overall result — and how far you need to<br/> go.</div>
              `,
    },
    {
      icon: TestEnvironmentIcon,
      title: "Identify which section to prioritise.",
      content: `
                <div class='text-start'>Because PTE’s integrated scoring means some tasks affect multiple skill areas,<br/> improving certain sections has an outsized impact on your overall score. Boosting<br/> your Listening from 55 to 65 might raise your overall score more than you’d<br/> expect, because several Listening tasks also contribute to Reading and Writing.</div>
              `,
    },
    {
      icon: checkList,
      title: "Track improvement over time",
      content: `
                <div class='text-start'>After each mock test, plug your section scores into the calculator to see how your<br/> predicted overall score is trending. This gives you a clear, objective measure of<br/> progress — and can be a powerful motivator when preparation feels overwhelming.</div>
              `,
    },
    {
      icon: Filter,
      title: "Decide when you’re ready to book the real exam",
      content: `
                <div class='text-start'>The most common mistake PTE students make is booking the exam too early. If<br/> our calculator consistently shows you hitting your target overall score across<br/> 2–3 mock tests, that’s a reliable signal you’re ready.</div>
              `,
    },
  ];

  const openPopup = () => {
    const modalElement = document.getElementById("staticBackdrop");
    const BootstrapModal = window?.bootstrap?.Modal;
    if (!modalElement || !BootstrapModal) return;
    const modal = new BootstrapModal(modalElement);
    modal.show();
  };

  const faqQuestions = [
    {
      question: "What is 65 in PTE equivalent to?",
      answer:
        "A PTE score of 65 overall aligns with IELTS 7.0 overall (per the official July 2025 alignment table, PTE 63–70 = IELTS 7.0). In the Australian immigration context, scoring 65 in each communicative skill (Speaking, Writing, Reading, and Listening) qualifies as “proficient English” and earns you 10 points on the skilled migration points test.",
    },
    {
      question: "Is 79 a good score in PTE?",
      answer:
        "79 is an excellent PTE score. It aligns with IELTS 8.0 overall (per the official alignment, PTE 79–85 = IELTS 8.0) and is classified as “superior English” by the Australian Department of Home Affairs. Achieving 79+ in all four sections earns you the maximum 20 English language points on your visa application, which can significantly strengthen your case for permanent residency.",
    },
    {
      question: "How is the PTE overall score calculated?",
      answer:
        "The PTE overall score is NOT a simple average of your four communicative skills. Instead, it uses an integrated scoring system that weighs your performance across all four communicative skills (Speaking, Writing, Reading, Listening) and six enabling skills (grammar, oral fluency, pronunciation, spelling, vocabulary, written discourse). Because many question types contribute to multiple skills simultaneously, the overall score reflects this complex weighting rather than arithmetic averaging.",
    },
    {
      question: "Can mock tests predict my PTE score?",
      answer:
        "Yes, if the mock tests use AI scoring calibrated to the official PTE scoring system. At Language Academy, our AI-scored mock tests are designed to closely replicate real exam conditions and scoring criteria. We recommend taking 2–3 full mock tests and using the average of your scores as a reliable predictor of your real PTE result.",
    },
    {
      question: "What PTE score is required for Australian PR?",
      answer:
        "For most Australian skilled migration visas (subclasses 189, 190, 491), you need a minimum of 65 in each communicative skill to claim “proficient English” points, or 79+ in each skill for “superior English” — which earns the maximum language points. Always check the current Department of Home Affairs guidelines as requirements can change.",
    },
  ];
  return (
    <React.Fragment>
      <Helmet>
        <title>PTE Scoring Guide & Score Calculator | LA Language Academy</title>
        <meta
          name="description"
          content="Understand the PTE scoring system with our detailed score calculation, section-wise marking, AI scoring insights & expert tips to improve your overall PTE score."
        />
        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://www.languageacademy.com.au/pte-score-calculator"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@languageacademy" />
        <meta
          name="twitter:title"
          content="PTE Scoring Guide & Score Calculator | LA Language Academy"
        />
        <meta
          name="twitter:description"
          content="Understand the PTE scoring system with our detailed score calculation, section-wise marking, AI scoring insights & expert tips to improve your overall PTE score."
        />
        <meta
          name="twitter:image"
          content="https://www.languageacademy.com.au/images/logol.png"
        />
        <meta name="twitter:image:alt" content="LA Language Academy Logo" />
        <meta
          property="og:url"
          content="https://www.languageacademy.com.au/pte-score-calculator"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="PTE Scoring Guide & Score Calculator | LA Language Academy"
        />
        <meta
          property="og:description"
          content="Understand the PTE scoring system with our detailed score calculation, section-wise marking, AI scoring insights & expert tips to improve your overall PTE score."
        />
        <meta
          property="og:image"
          content="https://www.languageacademy.com.au/images/logol.png"
        />
        <meta property="og:image:alt" content="LA Language Academy Logo" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
      </Helmet>
      <Header />

      <section className="new-design">
        <NocBanner
          data={heroData}
          extraClass={"contact-hero-section pte-scoring"}
          extraClass2={"align-items-start"}
        />
        <div className="fame-wall off-white">
          <ReusableHomePageSlider images={images} />
        </div>
        <div className="d-flex align-items-center gap-4 flex-column pb-4 off-white">
          {heroDescriptionSection()}
          <ButtonComp
            // link={() => {
            // const modal = new window.bootstrap.Modal(document.getElementById('staticBackdrop'));
            // modal.show();
            // }}
            btnText={"Try Calculator Now"}
          />

          {/* <div className="academy-highlight-box">
            📊 [ Embed interactive PTE Score Calculator tool here — input fields
            for Speaking, Writing, Reading, Listening scores with instant
            overall score output ]
          </div> */}
        </div>
        <div className="custom-container py-4">
          {PteIeltsScore()}
          <div className="py-5">
            <DynamicTable headers={headers} rows={rows} />
          </div>
          <InfoNotice
            title="Important"
            description="PTE 65+ overall does not automatically mean all sections are at IELTS 7.0 equivalence. PTE 65 overall aligns with IELTS 7.0 overall, but for Australian PR requiring 65 in each communicative skill, you need to verify that each individual section meets the requirement."
          />
        </div>

        <div className="custom-container py-4">
          {PteCibScore()}
          <ScoreInfoCard
            icon="/images/web-new-images/icons/blue-speaking.svg"
            title="Speaking Score Calculation"
            tableNote="Here’s how each task type contributes:"
            subtitle="Speaking tasks are scored on content accuracy, oral fluency and pronunciation"
            color="#0286FF"
            tableHeaders={[
              "Task Type",
              "What AI Scores",
              "Also Contributes To",
            ]}
            tableRows={[
              ["Read Aloud", "Content, Pronunciation, Oral Fluency", "–"],
              [
                "Repeat Sentence",
                "Content, Pronunciation, Oral Fluency",
                "Listening",
              ],
              ["Describe Image", "Content, Pronunciation, Oral Fluency", "–"],
              [
                "Retell Lecture",
                "Content, Pronunciation, Oral Fluency",
                "Listening",
              ],
              ["Answer Short Question", "Vocabulary", "–"],
              [
                "Respond to a Situation",
                "Content, Pronunciation, Oral Fluency",
                "Listening",
              ],
              [
                "Summarise Group Discussion",
                "Content, Pronunciation, Oral Fluency",
                "Listening",
              ],
            ]}
            insight={{
              title: "Key Insight",
              description:
                "Repeat Sentence is highly impactful because it contributes to both your Speaking and Listening scores simultaneously. Doing well on Repeat Sentence boosts two sections at once; conversely, struggling here affects both sections. The Summarise Group Discussion task also contributes to Listening, making it a high-value task for integrated skill improvement.",
            }}
          />

          <ScoreInfoCard
            icon="/images/web-new-images/icons/green-writing.svg"
            title="Writing — AI + Human Review for Critical Traits"
            subtitle="Writing is assessed through two task types:"
            color="#2E9E06"
            features={[
              {
                title: "Summarise Written Text (2 questions)",
                desc: "Scored on content (0–4), form (0–1), grammar (0–2), vocabulary (0–2), spelling (0–2). Also contributes to your Reading score because the AI checks whether you understood the passage.",
              },
              {
                title: "Write Essay (1 question)",
                desc: "Scored on content (0–6), form (0–2), development/structure/coherence (0–6), grammar (0–2), general linguistic range (0–6), vocabulary range (0–2), spelling (0–2). This is a Writing-only task.",
              },
            ]}
            insight={{
              title: "Language Academy Tip",
              description:
                "Many students spend hours perfecting their essay writing but neglect Summarise Written Text. Both tasks contribute to your Writing score, and SWT also boosts your Reading. Don’t skip it in your practice sessions.",
            }}
          />

          <ScoreInfoCard
            icon="/images/web-new-images/icons/yellow-reading.svg"
            title="Reading Score Calculation"
            tableNote="Each has different scoring criteria:"
            subtitle="Reading contains five distinct task types."
            color="#FFB02C"
            tableHeaders={[
              "Task Type",
              "What AI Scores",
              "Scoring",
              "Negative Marking?",
            ]}
            tableRows={[
              ["Fill in the Blanks (Dropdown)", "5-6", "Partial Credit", "No"],
              [
                "Multiple Choice, Multiple Answers",
                "2-3",
                "Partial credit (+1 per correct, −1 per incorrect)",
                "Yes",
              ],
              [
                "Reorder Paragraph",
                "2-3",
                "Partial credit (correct adjacent pairs)",
                "No",
              ],
              [
                "Fill in the Blanks (Drag & Drop)",
                "4-5",
                "Partial Credit",
                "No",
              ],
              [
                "Multiple Choice, Single Answer",
                "2-3",
                "Correct or incorrect",
                "No",
              ],
            ]}
            insight={{
              title: "Strategy note",
              description:
                "For Multiple Choice — Multiple Answers, only select options you’re confident about. Guessing incorrectly costs you a point, so it’s better to choose two answers you’re sure of than to tick four and get two wrong.",
            }}
          />
          <ScoreInfoCard
            icon="/images/web-new-images/icons/purple-listening.svg"
            title="Listening Score Calculations"
            subtitle="Listening contains the widest variety of question types, and several contribute to other skill scores:"
            color="#7F56D9"
            features={[
              {
                title: "Summarise Spoken Text (1 questions)",
                desc: "Scored on content (0–4), form (50–70 words), grammar (0–2), vocabulary (0–2), spelling (0–2). Contributes to both Listening and Writing scores.",
              },
              {
                title: "Multiple Choice tasks (2–3 total)",
                desc: "Same scoring as Reading MCQs — single answer is correct/incorrect; multiple answer uses partial credit with negative marking. Listening only.",
              },
              {
                title: "Fill in the Blanks (Type In) (2–3 questions)",
                desc: "One point per correct word. Listening only.",
              },
              {
                title: "Highlight Correct Summary (2–3 questions)",
                desc: "Correct or incorrect. Contributes to Listening and Reading.",
              },
              {
                title: "Multiple Choice, Single Answer (2–3 questions)",
                desc: "Correct or incorrect. Listening only.",
              },
              {
                title: "Select Missing Word (1–2 questions)",
                desc: "Correct or incorrect. Listening only.",
              },
              {
                title: "Highlight Incorrect Words (2–3 questions)",
                desc: "Partial credit with negative marking. Contributes to Listening and Reading.",
              },
              {
                title: "Write from Dictation (3–4 questions)",
                desc: "One point per correct word (partial credit). Contributes heavily to both Listening and Writing scores.",
              },
            ]}
            insight={{
              title: "High-value task alert",
              description:
                "Write from Dictation is arguably the single most important question type in PTE. It contributes to both Listening and Writing scores, and the scoring is straightforward — every correctly spelled word earns a point. Practise this task type daily. Even improving by 2–3 words per question can significantly boost your overall score.",
            }}
          />
        </div>

        <div className="custom-container py-4">
          {GoodPteScore()}
          <div className="py-4">
            <DynamicTable headers={GoodPteheaders} rows={GoodPterows} />
          </div>
          <p
            className="plus-sans FS16FW500 text-center w-75 mx-auto"
            style={{ color: "#525252" }}
          >
            If you’re targeting Australian permanent residency, the two most
            common benchmarks are 65+ overall (roughly IELTS 7.0) and 79+
            overall (roughly IELTS 8.0). Reaching 79+ in all sections earns you the maximum English language points on your visa
            application — and it can make a real difference to your overall
            points score. Note that for proficient or superior English claims,
            each communicative skill (Speaking, Writing, Reading, Listening)
            typically needs to meet the threshold individually, not just the
            overall score.
          </p>
        </div>
        <div
          className="text-center py-4 FS24FW500 fw-600 "
          style={{ background: "#F5F1FC", padding: "30px 120px" }}
        >
          Over 3,000 Language Academy students have achieved PTE 79+ in
          2024–2025
        </div>

        <SkillAreas
          skillAreaTitle={skillAreaTitle}
          skillSubtitle="<span>When you receive your PTE score report, it contains more information than just your overall score.<br/> Understanding each component helps you identify your strengths and pinpoint areas that need<br/> improvement — especially if you need to re-sit the exam.</span>"
          lifestyleCards={lifestyleCards}
          MiddleInfoSection={[
            "<p class='fw-300 FS16FW500 plus-sans text-start'> <span class='fw-700 FS22'>Pro Tip</span><br/><br/>If you didn’t reach your target score, log into your online Skills Profile to access the full diagnostic breakdown. It will tell you which specific language features — such as grammar, pronunciation, vocabulary, spelling — are holding you back. This is your roadmap for targeted improvement.</p>",
          ]}
          headerCenter={true}
          center="justify-content-center"
          barWidth="w-100"
        //  className={"text-center d-flex flex-column align-items-center justify-content-center"}
        //  skillBottomtitle={"Your schedule doesn't have to limit your success."}
        />
        <div>
          <div className="custom-container py-5 text-center">
            {laPreprationWorkTitle()}
            <p>
              A PTE score calculator isn’t just a fun tool — it’s a strategic
              preparation asset. Here’s how students at Language Academy use it
            </p>
            <div className="row">
              {calculatorArray.map((card, index) => (
                <div key={index} className="col-12 col-md-6 mb-4">
                  <SkillCard card={card} />
                </div>
              ))}
            </div>
            <div className="text-center">
              <p
                className="FS16FW500 fw-700 plus-sans mb-5"
                style={{ color: "#182A4F", fontStyle: "italic" }}
              >
                Done calculating? Now practise the sections that need the most
                work.
              </p>
              <ButtonComp
                btnText={"Start Free Mock Test "}
                link={"/auth/register"}
              />
            </div>
          </div>
        </div>
        <div className="custom-container py-5">
          <ContentImageSection
            contentSection={contentSection}
            quoteText={
              "Knowing your score is just the starting point. The real value comes from understanding why you got that score — and knowing exactly what to do to improve it. Language Academy’s AI-powered mock tests don’t just give you a number; they give you a complete diagnostic breakdown of your performance across every task type and every scoring criterion."
            }
            listBottomText={"<span class='fw-700'>Your target PTE score is within reach. Start practising with AI-scored mock tests today.</span>"}
            btnLink="/auth/login"
            // btnLink={()=>{
            //   const modal = new window.bootstrap.Modal(document.getElementById('staticBackdrop'));
            //   modal.show();
            // }}
            btnText="Start Free Mock Test"
            btnClassName="mt-4"
            image={Immigration}
            imageClassName="immigration-test-img"
            reverse={true}
            paragraphs={[
              "Whether you’re aiming for 65+ overall for Australian PR, 79+ for maximum points, or any score in between, our platform gives you the tools, the feedback, and the practice you need to get there. Thousands of students have used Language Academy to hit their target PTE scores — and you can too.",
            ]}
          />
        </div>
        
        <CtaBanner
          title="Ready To Test Your"
          highlight="Level?"
          buttonText="Book Free Consultation"
          onClick={openPopup}
          rightImage="/images/web-new-images/HomePageImage/CTA-Image.webp"
          btnText="Take Free Mock Test"
          subTitle={
            "Take a free mock test and understand your current standing before enrolling."
          }
        />
        <FaqSection questions={faqQuestions} />
        <Footer />
      </section>
    </React.Fragment>
  );
});

const DynamicTable = ({ headers = [], rows = [] }) => {
  return (
    <div className="table-responsive custom-table-wrapper">
      <table className="table custom-table mb-0">
        <thead>
          <tr>
            {headers.map((heading, index) => (
              <th className="FS20FW500 fw-600 ai-heading" key={index}>
                {heading}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {row.map((cell, cellIndex) => (
                <td key={cellIndex}>{cell}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const InfoNotice = ({
  title = "Important",
  description = "",
  icon = "/images/web-new-images/icons/idea-bulb.svg",
  className = "",
}) => {
  return (
    <div className={`info-notice ${className}`}>
      <div className="d-flex align-items-start gap-2">
        {icon && (
          <img src={icon} alt={title} className="info-icon" loading="lazy" />
        )}

        <div>
          <h3 className="mb-2 fw-600 FS20FW500">{title}</h3>

          <p className="mb-0 title FS16FW500">{description}</p>
        </div>
      </div>
    </div>
  );
};

const SkillCard = ({ card }) => {
  return (
    <div className="skill-card h-100 p-4">
      {/* Icon + Title */}
      <div className="d-flex align-items-center mb-3">
        <div className="me-3 col-auto">
          <img src={card.icon} alt={card.title || ""} />
        </div>
        <h6 className="text-start mb-0 plus-sans FS24FW500 fw-700 to-unset-transform col-11">
          {card.title}
        </h6>
      </div>

      {/* Content */}
      <div className="quote-para FS16FW500" style={{ lineHeight: "28px" }}>
        {typeof card.content === "string"
          ? ReactHtmlParser(card.content)
          : card.content}
      </div>
    </div>
  );
};
export default PteScoreSeo;
